import { render, staticRenderFns } from "./newMaterialVoiceRec.vue?vue&type=template&id=505e8802&scoped=true&"
import script from "./newMaterialVoiceRec.vue?vue&type=script&lang=js&"
export * from "./newMaterialVoiceRec.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialVoiceRec.vue?vue&type=style&index=0&id=505e8802&lang=less&scoped=true&"
import style1 from "./newMaterialVoiceRec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e8802",
  null
  
)

component.options.__file = "newMaterialVoiceRec.vue"
export default component.exports